import { Controller } from "@hotwired/stimulus"

// A single auto-dismissing toast. Slides+fades in on connect, then removes
// itself after `delay` ms (default 3000). The dismiss button closes it early.
// The element is rendered visible (no-JS still shows the message); the enter
// animation is driven entirely here so it degrades gracefully.
export default class extends Controller {
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    this.element.classList.add("opacity-0", "translate-x-3")
    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-x-3")
    })
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  dismiss() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    const remove = () => this.element.remove()
    this.element.addEventListener("transitionend", remove, { once: true })
    this.element.classList.add("opacity-0", "translate-x-3")
    // Fallback in case transitionend never fires (reduced motion, detached).
    setTimeout(remove, 400)
  }
}
